export const FETCH_BEEF_BODIES_REQUEST = "FETCH_BEEF_BODIES_REQUEST";
export const FETCH_BEEF_BODIES_SUCCESS = "FETCH_BEEF_BODIES_SUCCESS";
export const FETCH_BEEF_BODIES_FAILURE = "FETCH_BEEF_BODIES_FAILURE";
export const CREATE_BEEF_BODY_REQUEST = "CREATE_BEEF_BODY_REQUEST";
export const CREATE_BEEF_BODY_SUCCESS = "CREATE_BEEF_BODY_SUCCESS";
export const CREATE_BEEF_BODY_FAILURE = "CREATE_BEEF_BODY_FAILURE";

export const fetchBeefBodiesRequest = () => ({
  type: FETCH_BEEF_BODIES_REQUEST,
});

export const fetchBeefBodiesSuccess = (beefBody) => ({
  type: FETCH_BEEF_BODIES_SUCCESS,
  payload: beefBody,
});
export const fetchBeefBodiesFailure = (error) => ({
  type: FETCH_BEEF_BODIES_FAILURE,
  payload: error,
});

export const createBeefBodyRequest = () => ({
  type: CREATE_BEEF_BODY_REQUEST,
});

export const createBeefBodySuccess = (createdBeefBodies) => ({
  type: CREATE_BEEF_BODY_SUCCESS,
  payload: createdBeefBodies,
});

export const createBeefBodyFailure = (error) => ({
  type: CREATE_BEEF_BODY_FAILURE,
  payload: error,
});
